<p>Manually fetch and activate the latest Remote Config values from Firebase.</p>
<ion-button
  (click)="fetchRemoteConfig()"
  [disabled]="isFetchingRemoteConfig"
  expand="block"
  color="primary"
>
  @if (isFetchingRemoteConfig) {
    <ion-spinner name="crescent" slot="start"></ion-spinner>
    Fetching...
  } @else {
    Fetch & Activate Remote Config
  }
</ion-button>
